import React from 'react';
import DocumentoNoDisponible from './DocumentoNoDisponible';

const CompendioCap2 = () => (
  <DocumentoNoDisponible titulo="Compendio Estadístico 2017 - 2021 · Capítulo 2" />
);

export default CompendioCap2;
